<template>
  <div>
    <v-container>
      <template>
        <div class="text-center">
          <v-dialog
            v-model="dialog"
            width="829"
            @click:outside="closeModal"
            :retain-focus="false"
          >
            <v-card class="custom-card" rounded="0">
              <v-toolbar
                color="secondary"
                class="white--text"
                style="height: 50px !important"
              >
                <v-toolbar-title class="font-weight-bold">
                  Save Ration
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon class="white--text" @click="closeModal">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-form ref="addUser" lazy-validation autocomplete="off">
                <div
                  class="pt-5 pl-5 pr-5"
                  style="width: 100%; overflow: hidden"
                >
                  <v-row>
                    <v-col cols="2">
                      <v-sheet
                        class="pa-2 ma-2"
                        style="font-size: 14px; color: #aeaeae"
                      >
                        Animal ID :
                      </v-sheet>
                    </v-col>
                    <v-col>
                      <v-sheet class="pa-2 ma-2" style="font-size: 18px">
                        {{ rationLists.animalId }}
                      </v-sheet>
                    </v-col>
                  </v-row>

                  <v-card-text class="black--text">
                    <v-row class="mt-0 ration-dialog-text">
                      <v-col cols="12">
                        <label class="">Ration Id</label>
                        <v-text-field
                          type="text"
                          outlined
                          v-model="rationData.rationCode"
                          readonly="true"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="mt-0 ration-dialog-text">
                      <v-col cols="12">
                        <label class="">Ration Name</label>
                        <v-text-field
                          type="text"
                          outlined
                          placeholder="Enter Ration Name"
                          v-model="rationData.rationName"
                        >
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row class="mt-0 ration-dialog-text">
                      <v-col cols="12">
                        <label class=""
                          >Duration <span class="red--text">*</span></label
                        >

                        <v-select
                          :items="duration"
                          item-text="name"
                          item-value="id"
                          outlined
                          dense
                          placeholder="Select duration"
                          v-model="rationData.duration"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-checkbox
                      label="Notify Me"
                      :value="rationData.notify_me"
                      v-model="rationData.notify_me"
                      @click="!rationData.notify_me"
                    ></v-checkbox>
                    <v-card-actions class="mt-2" style="padding-right: 0">
                      <v-spacer></v-spacer>
                      <v-btn
                        @click="closeModal"
                        outlined
                        class="mr-2 px-5"
                        right
                        height="44"
                        depressed
                        color="primary"
                      >
                        CANCEL
                      </v-btn>
                      <v-btn
                        @click="saveRationForIndividual"
                        right
                        height="44"
                        color="primary"
                        class="px-5"
                      >
                        Save Ration
                      </v-btn>
                    </v-card-actions>
                  </v-card-text>
                </div>
              </v-form>
            </v-card>
          </v-dialog>
        </div>
      </template>
    </v-container>
  </div>
</template>
<script>
import {
  saveRation,
  generateIngredientIndividualAnimal,
} from "@/graphql/FeedMgmt.gql";
import loadingMixin from "@/mixins/LoadingMixin";
export default {
  data() {
    return {
      duration: [
        { id: "1 day", name: "1 day" },
        { id: "2 days", name: "2 days" },
        { id: "3 days", name: "3 days" },
        { id: "4 days", name: "4 days" },
        { id: "5 days", name: "5 days" },
        { id: "6 days", name: "6 days" },
        { id: "7 days", name: "7 days" },
      ],
      rationData: {
        rationId: null,
        rationName: null,
        duration: null,
        notify_me: false,
        rationCode: "Ration #" + new Date().getTime(),
        // statusType: null,
      },
      rationList: [],
    };
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
    rationLists: {
      type: Object,
      required: true,
    },
    saveRationType: {
      type: String,
      required: true,
    },
    suggestionType: {
      type: String,
      required: true,
    },
  },
  mixins: [loadingMixin],
  methods: {
    getSubGroups() {
      const subGroupNameArray = this.rationLists.subGroup?.map((s) => {
        return s.subGroupName;
      });

      return subGroupNameArray.join(",");
    },
    rationCreated() {
      this.$emit("rationCreated");
    },
    closeModal() {
      this.$emit("closeDialog");
    },

    editRation(index) {
      this.rationLists[index].updateMode = true;
    },

    updateRation(index) {
      this.rationLists[index].updateMode = false;
      this.saveRation("single", this.rationLists[index]);
    },

    async saveRation(saveType, ration = null) {
      console.log(saveType);
      console.log(ration);
      this.startLoading();
      await this.$apollo
        .mutate({
          mutation: saveRation,
          variables: {
            saveRationInput: {
              rationId: this.rationLists[0].rationId,
              rationName: this.rationLists[0].rationName,
            },
          },
        })
        .then((res) => {
          this.stopLoading();
          if (res?.data) {
            this.rationCreated();
          }
        })
        .catch(() => {
          this.stopLoading();
          this.$notify({
            title: "Error!",
            text: "Error occured while saving rations.",
            type: "error",
          });
        });
    },

    async saveRationForIndividual() {
      this.startLoading();
      await this.$apollo
        .mutate({
          mutation: generateIngredientIndividualAnimal,
          variables: {
            generateIngredientIndividualInput: {
              ...this.rationData,
            },
          },
        })
        .then((res) => {
          this.stopLoading();

          if (res?.data) {
            this.rationCreated();
          }
        })
        .catch((error) => {
          this.stopLoading();
          this.$notify({
            title: "Error!",
            text: error.message,
            type: "error",
          });
        });
    },
    prepareRationData() {
      return this.rationLists.map((ration) => {
        return {
          rationId: ration.rationId,
          rationName: ration.rationName,
        };
      });
    },

    prepareGroupRationData() {
      const subGroupIngredients = this.rationLists?.subGroup.map((s) => {
        return {
          subGroupId: +s.id,
          percentageNutrientRequirement: 100,
          suggestionType:
            this.$route.query.rationPriority === "lowest_price"
              ? "low-cost"
              : "expiry",
        };
      });

      return [
        {
          groupId: this.rationLists?.groupId,
          subGroupIngredients,
        },
      ];
    },
  },
  mounted() {
    this.rationData.rationId = this.rationLists.ration.id;
    this.rationData.rationCode = this.rationLists.ration.rationCode;
    this.rationData.rationName = this.rationLists.ration.name;
    this.rationData.duration = this.rationLists.ration.duration;
    this.rationData.notify_me = this.rationLists.ration.notify_me;
    this.rationData.animalId = +this.rationLists.animalId;
    this.rationData.suggestionType = this.suggestionType;
    this.rationData.percentageNutrientRequirement = 100;
  },
};
</script>

<style scoped>
::v-deep .v-input__slot {
  min-height: 45px !important;
}

::v-deep .ration-dialog-text {
  max-height: 100px !important;
}

::v-deep .row + .row {
  margin-top: 0px !important;
}

/* ::v-deep .v-text-field--enclosed .v-input__append-inner {
    margin-top: 10px;
  }
  
  ::v-deep .v-input__control fieldset {
    border: none;
  }
  ::v-deep .v-input__slot fieldset:first-child {
    border-top: 1px solid #bbb;
  }
  ::v-deep .v-form span:last-child .v-input__slot fieldset {
    border-bottom: 1px solid #bbb;
  }
  ::v-deep .highlightedInput {
    border: 1px solid #00bd73;
    border-width: 1px 0 1px 0;
    border-radius: 0;
  } */
</style>
